import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { ExposedListAzureEnvironmentReservationRes } from 'app/interfaces/responses/Exposed/exposedListAzureEnvironmentReservationRes';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-azure-environment-reservations-list',
    templateUrl: './azure-environment-reservations-list.component.html'
})
export class AzureEnvironmentReservationsListComponent implements AfterViewInit, OnChanges, OnDestroy {
    @ViewChild('tablePaginator') tablePaginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;

    @Input() reservations: ExposedListAzureEnvironmentReservationRes[] = [];
    @Input() selectedEnvironment: string = '';
    @Output() deleteClicked = new EventEmitter<number>();

    tableColumns: string[] = ['reservedByUserName', 'reservationTicketId', 'reservationStartTime', 'reservationEndTime', 'reason', 'action'];
    dataSource = new MatTableDataSource<ExposedListAzureEnvironmentReservationRes>([]);

    private subs = new Subscription();

    constructor(private fuseConfirmationService: FuseConfirmationService) {}

    ngAfterViewInit(): void {
        this.dataSource.paginator = this.tablePaginator;
        this.dataSource.sort = this.sort;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['reservations']) {
            this.dataSource.data = this.reservations ?? [];
        }
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    delete(reservationId: number): void {
        const dialog = this.fuseConfirmationService.open({
            title: 'Eyða frátekt',
            message: 'Ertu viss um að þú viljir eyða þessari frátekt?',
            actions: {
                confirm: { label: 'Eyða', color: 'warn' },
                cancel: { label: 'Hætta við' },
            },
        });

        this.subs.add(
            dialog.afterClosed().subscribe((result) => {
                if (result === 'confirmed') {
                    this.deleteClicked.emit(reservationId);
                }
            })
        );
    }
}
